
import React, { useState, useEffect,useRef   } from "react";
import {  useSelector } from 'react-redux';
import { createSelector } from "@reduxjs/toolkit";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, Bar, ResponsiveContainer, CartesianGrid, ReferenceLine,Area } from "recharts";
import { Table,Row, Col,Button,Card ,Badge } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import { CheckCircle, XCircle  } from "lucide-react";
import { useDispatch } from "react-redux";
import { GetListDataHeigthOfUser } from "../../../../core/store/data-dashboard/thunk";
import {  GetAllDietPlanByUser, GetAllProgresProgramOfUser } from '../../../../core/store/diet/dietPan/thunk';
import moment from "moment";
import { toast , ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNotification } from "../../../../context/NotificationContext";
import "../../../../css/workplan.css"
import WaterBottle from "../../../components/Dashboard/waterBottle";


const selectDietPlan = (state) => state.DietPlan;
//const selectListHeigth = (state) => state.data_heigth;

const selectMeals = createSelector(
  selectDietPlan,
  (dietPlan) => {
    // Vérifier si le mealPlan existe et contient des dailyPlans
    if (!dietPlan.mealPlans || dietPlan.mealPlans.length === 0) {
      return [];
    }
    
    // Extraire tous les dailyMeals des dailyPlans
    return dietPlan.mealPlans.flatMap(mealPlan => 
      mealPlan.dailyPlans.flatMap(dailyPlan => dailyPlan.dailyMeals)
    );
  }
);



const NutritionDashboard = ({ dietPlans }) => {
  const [dailyPlan, setDailyPlan] = useState(null);
  const [calorieGoal, setCalorieGoal] = useState(null);
  const [weightHistory, setWeightHistory] = useState([]); // Stocker les données API
  const [timeFrame, setTimeFrame] = useState("week");
  const caloriesConsumed = 1800;
  const [filter, setFilter] = useState("week");
  const dispatch = useDispatch();
  const [mealPlans, setMealPlans] = useState([]);
  const [nextDailyPlanId, setNextDailyPlanId] = useState(null);
  const [nextDailyPlan, setNextDailyPlan] = useState(null);
  const [caloriePercentage, setCaloriePercentage] = useState(0);
  const [dailyGoal, setDailyGoal] = useState({});
  const [dailyProgress, setDailyProgress] = useState({});
  const [percentageProgress, setPercentageProgress] = useState({});

   const [consumedCalories, setConsumedCalories] = useState(0);
  const [totalCalories, setTotalCalories] = useState( 0);
  const [percentage, setPercentage] = useState( 0);

  const { showNotification } = useNotification(); 
  const [chartData, setChartData] = useState([]);
  const hasNotified = useRef(false);
  
 
 
  useEffect(() => {
    const userId = JSON.parse(sessionStorage.getItem("authUser"))?.data?.userId;
  
    if (userId) {
      dispatch(GetAllDietPlanByUser(userId))
        .then((result) => {
          const plans = result.payload?.data|| [];
          setMealPlans(plans);
          console.log('plans in nutritionnal :', plans);
          const todayDate = moment().format("YYYY-MM-DD");
          let todayPlan = null;
          const transformedData = transformMealData(plans);
          setChartData(transformedData);
  
          plans.forEach((plan) => {
            const foundPlan = plan.dailyPlans.find((dailyPlan) => dailyPlan.dailyDate === todayDate);
            if (foundPlan) {
              todayPlan = foundPlan;
            }
          });
  
          setNextDailyPlan(todayPlan || null);
          setNextDailyPlanId(todayPlan?.id || null);
  
          // Calcul des calories
          let totalConsumed = 0;
          let totalDailyGoal = 0;
          let totalNotConsumed = 0;
      
          // Boucle sur chaque plan
         
          plans.forEach((plan) => {
            if (plan.dailyPlans) {
              plan.dailyPlans.forEach((dailyPlan) => {
                dailyPlan.dailyMeals.forEach((meal) => {
                  const nv = meal.recipe?.totalNV;
                  const calories = nv?.calories;

                  if (nv && typeof calories === 'number') {
                    if (meal.consumed) {
                      totalConsumed += calories;
                    } else {
                      totalNotConsumed += calories;
                    }
                  }
                });
              });
            }
          });
      
          // Mise à jour de totalDailyGoal après la boucle
          totalDailyGoal = totalConsumed + totalNotConsumed;
      
        
      
          console.log('Calorie consommée :', totalConsumed);
          console.log('Calorie non consommée :', totalNotConsumed);
          console.log('Calorie total somme :', totalDailyGoal);
      
          setTotalCalories(totalDailyGoal);
          setConsumedCalories(totalConsumed );

            // Calcul du pourcentage
            const percentage =
            totalDailyGoal > 0
              ? Math.min((totalConsumed / totalDailyGoal) * 100, 100)
              : 0;
          

          setPercentage(percentage);
          
        })
        .catch((error) => {
          console.error("Erreur:", error);
        });
    }
  }, [dispatch]);
  
  
 // Fonction pour transformer les données des repas en données pour le graphique
 const transformMealData = (plans) => {
  const result = [];
  
  plans.forEach(plan => {
    plan.dailyPlans?.forEach(dailyPlan => {
      const dailyData = {
        date: moment(dailyPlan.dailyDate).format('DD/MM'),
        caloriesConsumed: 0,
        caloriesBurned: 0,
        proteins: 0,
        carbs: 0,
        fats: 0
      };

      // Calcul des calories consommées (à partir des repas)
      dailyPlan.dailyMeals?.forEach(meal => {
        if (meal.recipe) {
          dailyData.caloriesConsumed += meal.recipe.totalNV?.calories || 0;
          dailyData.caloriesBurned += meal.recipe.caloriesBurnedOfMeal || 0;
          dailyData.proteins += meal.recipe.totalNV?.protein || 0;
          dailyData.carbs += meal.recipe.totalNV?.carbs || 0;
          dailyData.fats += meal.recipe.totalNV?.fats || 0;
        }
      });

      // Calcul des calories brûlées (à partir des activités)
      // dailyPlan.activities?.forEach(activity => {
      //   dailyData.caloriesBurned += activity.caloriesBurned || 0;
      // });
      console.log('dailyDatagraffe :', dailyData);

      result.push(dailyData);
    });
  });

  return result;
};

useEffect(() => {
  if (!nextDailyPlan || !Array.isArray(nextDailyPlan.dailyMeals) || hasNotified.current) {
    return; // Empêche l'affichage multiple des notifications
  }

  hasNotified.current = true; // Marque que la notification a été affichée
  const consumedMeals = nextDailyPlan.dailyMeals.filter((meal) => meal.consumed);

  if (consumedMeals.length === 0) {
    showNotification(
      "⚠️ Aucun repas consommé aujourd'hui. Essayez de rester sur la bonne voie !",
      "warn",
      { background: "#413c26", color: "#fff" }
    );
  } else if (consumedMeals.length === nextDailyPlan.dailyMeals.length) {
    showNotification(
      "🎉 Félicitations ! Vous avez atteint vos objectifs journaliers !",
      "success",
      { background: "#2E7D32", color: "#fff" }
    );
  } else if (consumedMeals.length === 1) {
    showNotification(
      "🍽️ Vous avez consommé un repas. Continuez ainsi !",
      "success",
      { background: "#42A5F5", color: "#fff" }
    );
  } else if (consumedMeals.length === 2) {
    showNotification(
      "✅ Deux repas consommés. Vous êtes sur la bonne voie !",
      "success",
      { background: "#66BB6A", color: "#fff" }
    );
  } else {
    showNotification(
      `🍴 Vous avez consommé ${consumedMeals.length} repas. Continuez !`,
      "success",
      { background: "#AB47BC", color: "#fff" }
    );
  }
}, [nextDailyPlan, showNotification]);
  // const findNextIncompleteDailyPlan = (mealPlans) => {
  //   return mealPlans
  //     .flatMap((plan) => plan.dailyPlans || []) // Vérifier si `dailyPlans` existe
  //     .filter((dailyPlan) => dailyPlan.status !== "IN_PROGRESS") // Filtrer les plans incomplets
  //     .sort((a, b) => new Date(b.dailyDate) - new Date(a.dailyDate)) // Trier par date croissante
  //     [0]; // Prendre le premier (prochain à consommer)
  // };
  
  useEffect(() => {
    if (!nextDailyPlanId) return; 
  
    dispatch(GetAllProgresProgramOfUser(nextDailyPlanId))
      .unwrap()
      .then((result) => {
        console.log("Succès progress data:", result);
  
        const goal = result.dailyGoal|| {};
        const progress = result.consumed
        ? { ...result.consumed, calories: result.consumed.calories === 0 ? 1 : result.consumed.calories }
        : { calories: 0 };

        const percentageProgress =
        goal.calories > 0 ? (progress.calories / goal.calories) * 100 : 1;
        setPercentageProgress(percentageProgress);

          console.log("Succès progress data goal:", goal);
          console.log("Succès progress data progress:", progress);
          console.log("Succès progress data:", percentageProgress);
      
        // Vérifier si les valeurs sont différentes avant mise à jour
        setDailyGoal((prevGoal) => 
          JSON.stringify(prevGoal) !== JSON.stringify(goal) ? goal : prevGoal
        );
  
        setDailyProgress((prevProgress) => 
          JSON.stringify(prevProgress) !== JSON.stringify(progress) ? progress : prevProgress
        );
  
        // Calcul du pourcentage et mise à jour uniquement si nécessaire
        setCaloriePercentage((prevPercentage) => {
          const newPercentage =
            goal.calories > 0
              ? progress.calories > 0
                ? (progress.calories / goal.calories) * 100
                : 1
              : 0;
        
          return prevPercentage !== newPercentage ? newPercentage : prevPercentage;
        });
        
        
      })
      .catch((error) => {
        console.error("Erreur:", error);
      });
  }, [dispatch, nextDailyPlanId]);
  
  
  
  console.log("Prochain Daily Plan:", nextDailyPlanId);



  const selectDataHeigthState = (state) => state;
  const DashboardDataHeigthData = createSelector(
    selectDataHeigthState,
        (state) => ({
          data_heigth: state.data_heigth,       
   })
  ); 



    useEffect(() => {
      console.log("Dispatching GetAllDietPlanServices...");
      const userId = JSON.parse(sessionStorage.getItem("authUser"))?.data?.userId;
      console.log("Dispatching GetAllDietPlanServices...", userId);
  
      if (userId) {
        dispatch(GetListDataHeigthOfUser(userId))
          .then((result) => {
            console.log("Succès list data heigth:", result.payload);
      
            // Créer une copie avant d'inverser
            const tabeWeight = [...(result.payload || [])].reverse();
      
            setWeightHistory(tabeWeight); // Stocker les données inversées dans le state
          })
          .catch((error) => {
            console.error("Erreur:", error);
          });
      } else {
        console.error("User ID not found in sessionStorage");
      }
      
      
    }, [dispatch]);
  
 const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("fr-FR", {
    weekday: "short", // Affiche "lun." au lieu de "lundi"
    day: "2-digit",
    month: "short",
  });
};

  
    // Transformation des données pour le graphe
    const transformedData = weightHistory.map((item) => ({
      date: formatDate(item.date),
      weight: item.weight,
    }));


  const dataDashboardPlan = useSelector(state => state.dataDashboardPlan) || {
    dailyGoal: { protein: 0, fats: 0, carbs: 0, calories: 0 },
    dailyProgress: { protein: 0, fats: 0, carbs: 0, calories: 0 },
    message: null,
  };

 // const { dailyGoal, dailyProgress, message } = dataDashboardPlan;



  const meals = useSelector(selectMeals);
  console.log("Meals:", meals);
 
  // const dietPlan = useSelector(state => state.dietPlan) || {
  //   error: "",
  //   loading: false,
  //   mealPlans: [],
   
  // };

  // const { error, loading, mealPlans} = dietPlan;
  // const meals = useSelector(state => state.dietPlan?.mealPlans || []);




 
  //let caloriePercentage = 0;

  const macroData = [
    { name: "Protéines", value: dailyProgress.protein, goal: dailyGoal.protein, color: "#75e4eb" },
   
    { name: "Glucides", value: dailyProgress.carbs, goal: dailyGoal.carbs, color: "#f5d25d" },
     { name: "Graisses", value: dailyProgress.fat, goal: dailyGoal.fats, color: "#FB8C00" },
  ];

console.log("macroData",macroData)
  const userGoal = "maintain"; // Peut être "lose", "gain" ou "maintain"

  const goalCalories = userGoal === "lose" ? 1800 : userGoal === "gain" ? 2800 : 2200; 
  
  const calorieData = [
    { date: "10 Mars", caloriesConsumed: 2100, caloriesBurned: 2500 },
    { date: "11 Mars", caloriesConsumed: 1900, caloriesBurned: 2300 },
    { date: "12 Mars", caloriesConsumed: 2200, caloriesBurned: 2200 },
    { date: "13 Mars", caloriesConsumed: 2500, caloriesBurned: 2400 },
    { date: "14 Mars", caloriesConsumed: 1800, caloriesBurned: 2600 },
    { date: "15 Mars", caloriesConsumed: 2000, caloriesBurned: 2250 },
    { date: "16 Mars", caloriesConsumed: 2300, caloriesBurned: 2350 },
  ];
  

 

  // useEffect(() => {
  //   // Afficher les données initiales dans la console à l'initialisation
  //   console.log("Daily Goal: ", dailyGoal);
  //   console.log("Daily Progress: ", dailyProgress);
  //   console.log("Message: ", message);
  // }, [dailyGoal, dailyProgress, message]); // Dépendances pour re-exécuter à chaque mise à jour des données
 


  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];

   

    console.log("Aujourd'hui :", today);
    console.log("dietPlans:", dietPlans);

    if (dietPlans?.mealPlans?.length > 0 && dietPlans.mealPlans[0]?.dailyPlans?.length > 0) {
      const foundDailyPlan = dietPlans.mealPlans[0].dailyPlans.find(plan => plan.dailyDate === today);
      
      console.log("Daily Plans :", dietPlans.mealPlans[0].dailyPlans);
      console.log("Found Daily Plan:", foundDailyPlan);

      setDailyPlan(foundDailyPlan || null);
      setCalorieGoal(foundDailyPlan?.dailyGoal?.calories ?? 0);
    }
}, [dietPlans]);





const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip" style={{ 
        backgroundColor: 'white', 
        padding: '10px', 
        border: '1px solid #e2e8f0',
        borderRadius: '4px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <p className="label" style={{ margin: 0, fontWeight: 'bold' }}>{label}</p>
        {payload.map((entry, index) => (
          <p key={index} style={{ 
            margin: '5px 0 0 0', 
            color: entry.stroke || entry.fill 
          }}>
            {entry.name}: {entry.value} cal
          </p>
        ))}
      </div>
    );
  }
  return null;
};
  return (

    
    <div className="grid">
      <div style={{ margin: "-4rem", backgroundColor: "#ffffff" }}>
        <ToastContainer /> {/* 🚀 Ajout du ToastContainer ici */}
        {console.log('nextDailyPlan:', nextDailyPlan, 'hasMeals:', nextDailyPlan?.dailyMeals?.length > 0)}
        {(!nextDailyPlan || !nextDailyPlan.dailyMeals || nextDailyPlan.dailyMeals.length === 0) ? (
          <div style={{ 
            padding: " 5px 20px 20px", 
            color: "#ff6b6b", 
            fontWeight: 500,
            backgroundColor: '#fff5f5',
            borderRadius: '8px',
            margin: '20px 20px',
            borderLeft: '4px solid #ff6b6b',
            textAlign: 'center',
          }}>
            <i className="ri-alert-line me-2"></i>
            Aucun repas n'a été trouvé pour aujourd'hui. Ajoutez des repas pour suivre votre consommation.
          </div>
        ) : null}
      </div>
      
      <div style={{ margin: "-4rem", backgroundColor: "#ffffff" }}>
      <Row className="g-3" style={{ padding: "15px 20px", display: 'flex',  alignItems: 'stretch', minHeight: 'auto' }}>
  {/* Première carte - Calories consommées */}
  <Col xs={12} lg={6} className="d-flex" style={{ minHeight: '100%' }}>
    <Card className="p-3 w-100 d-flex flex-column" style={{ boxShadow: '0 4px 20px rgba(0,0,0,0.05)', height: '100%', minHeight: '320px' }}>
      <div className="d-flex flex-column flex-lg-row justify-content-around align-items-center flex-grow-1">
        {/* Jauge du jour */}
        <div className="text-center mb-4 mb-lg-0" style={{ width: '100%', maxWidth: '300px' }}>
          <h4 className="mb-2" style={{ color: '#4a6baf', fontSize: '1.1rem' }}>Aujourd'hui</h4>
          <div style={{ width: '100%', maxWidth: '220px', margin: '0 auto' }}>
            {dailyGoal ? (
              <CircularProgressbar
                value={caloriePercentage}
                text={`${Math.round(caloriePercentage)}%`}
                styles={{
                  path: {
                    stroke: `#4a6baf`,
                    strokeLinecap: 'round',
                    transition: 'stroke-dashoffset 0.5s ease 0s',
                  },
                  trail: {
                    stroke: '#e0e0e0',
                  },
                  text: {
                    fill: '#4a6baf',
                    fontSize: '1.5rem',
                    fontWeight: 'bold',
                  },
                }}
                strokeWidth={10}
              />
            ) : (
              <div className="text-center p-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Chargement...</span>
                </div>
              </div>
            )}
            <div className="mt-1">
              <p className="h5">{dailyProgress.calories || 0} / {dailyGoal?.calories || 0} kcal</p>
              <p className="text-muted small">Objectif quotidien</p>
            </div>
          </div>
        </div>

        {/* Jauge du programme */}
        <div className="text-center" style={{ width: '100%', maxWidth: '300px' }}>
          <h4 className="mb-2" style={{ color: '#79ca31', fontSize: '1.1rem' }}>Programme</h4>
          <div style={{ width: '100%', maxWidth: '220px', margin: '0 auto' }}>
            <CircularProgressbar
              value={percentage}
              text={`${Math.round(percentage)}%`}
              styles={{
                path: {
                  stroke: `#79ca31`,
                  strokeLinecap: 'round',
                  transition: 'stroke-dashoffset 0.5s ease 0s',
                },
                trail: {
                  stroke: '#e0e0e0',
                },
                text: {
                  fill: '#79ca31',
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                },
              }}
              strokeWidth={10}
            />
            <div className="mt-3">
              <p className="h5 mb-1">{consumedCalories} / {totalCalories} kcal</p>
              <p className="text-muted small">Total du programme</p>
            </div>
          </div>
        </div>
      </div>

      {/* Légende et détails */}
      <div className=" pt-2 border-top text-center">
        <div className="d-flex justify-content-center gap-4">
          <div>
            <span className="d-inline-block rounded-circle me-2" style={{ width: '12px', height: '12px', backgroundColor: '#4a6baf' }}></span>
            <span>Objectif du jour</span>
          </div>
          <div>
            <span className="d-inline-block rounded-circle me-2" style={{ width: '12px', height: '12px', backgroundColor: '#79ca31' }}></span>
            <span>Objectif programme</span>
          </div>
        </div>
      </div>
    </Card>
  </Col>

  {/* Carte Hydratation */}
  <Col xs={12} lg={3} className="d-flex" style={{ minHeight: '100%' }}>
    <Card className="border-0 w-100" style={{
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      height: '100%',
      minHeight: '320px',
      borderRadius: '16px',
      boxShadow: '0 8px 32px rgba(31, 38, 135, 0.1)',
      overflow: 'hidden',
      position: 'relative',
      padding: '1.5rem'
    }}>
      <Card.Body className="d-flex flex-column p-0" style={{ height: '100%' }}>
        <div className="d-flex justify-content-between align-items-center mt-1 ">
          <h5 className="mb-0 fw-bold" style={{ color: '#2c3e50' }}>Hydratation</h5>
          <div style={{
          
            borderRadius: '50%',
            background: 'rgba(74, 107, 175, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <i className="fas fa-tint" style={{ color: '#4a6baf', fontSize: '18px' }}></i>
          </div>
        </div>

        <div style={{marginTop:"-1rem", paddingTop: '0.5rem'}}>
          <WaterBottle />
          <div className="d-flex justify-content-between align-items-center mt-0">
            <span className="text-muted small">Objectif quotidien</span>
            <span className="fw-bold" style={{ color: '#4a6baf' }}>2.5L</span>
          </div>
          <div className="progress mt-1" style={{ height: '8px', borderRadius: '4px' }}>
            <div 
              className="progress-bar" 
              role="progressbar" 
              style={{
                width: '75%',
                background: 'linear-gradient(90deg, #4a6baf 0%, #6c8ed4 100%)',
                borderRadius: '4px'
              }}
              aria-valuenow="75" 
              aria-valuemin="0" 
              aria-valuemax="100"
            ></div>
          </div>
        </div>
      </Card.Body>
    </Card>
  </Col>

  {/* Carte Évolution du Poids */}
  <Col xs={12} lg={3} className="d-flex" style={{ minHeight: '100%' }}>
    <Card className="border-0 w-100" style={{
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      height: '100%',
      minHeight: '320px',
      borderRadius: '16px',
      boxShadow: '0 8px 32px rgba(31, 38, 135, 0.1)',
      overflow: 'hidden',
      position: 'relative',
      padding: '1.5rem'
    }}>
      <Card.Body className="d-flex flex-column h-100 p-0" style={{ height: '100%' }}>
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0 fw-bold" style={{ color: '#2c3e50' }}>Évolution du poids</h5>
          <div style={{
            width: '36px',
            height: 'auto',
            borderRadius: '50%',
            background: 'rgba(121, 202, 49, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <i className="fas fa-weight" style={{ color: '#79ca31', fontSize: '18px' }}></i>
          </div>
        </div>

        <div style={{ height: '80px', flex: '1 1 auto' }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={transformedData}>
              <defs>
                <linearGradient id="colorWeight" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#79ca31" stopOpacity={0.8}/>
                  <stop offset="95%" stopColor="#79ca31" stopOpacity={0.1}/>
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e0e0e0" strokeOpacity={0.7} />
              <XAxis 
                dataKey="date"
                tick={{ fontSize: '11px', fill: '#6c757d' }}
                tickLine={false}
                axisLine={false}
                padding={{ left: 10, right: 10 }}
              />
              <YAxis 
                domain={['dataMin - 1', 'dataMax + 1']}
                tick={{ fontSize: '11px', fill: '#6c757d' }}
                tickLine={false}
                axisLine={false}
                tickFormatter={(value) => `${value} kg` }
                width={35}
              />
              <Tooltip 
                contentStyle={{
                  backgroundColor: 'rgba(255, 255, 255, 0.98)',
                  border: '1px solid rgba(0, 0, 0, 0.05)',
                  borderRadius: '8px',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                  padding: '8px 12px',
                  fontSize: '13px'
                }}
                labelStyle={{ color: '#6c757d', fontWeight: '500', marginBottom: '4px' }}
                formatter={(value) => [`${value} kg` , 'Poids']}
                itemStyle={{ padding: '2px 0', color: '#2c3e50', fontWeight: '600' }}
              />
              <Line 
                type="monotone" 
                dataKey="weight" 
                stroke="#79ca31" 
                strokeWidth={2.5}
                dot={{ fill: '#fff', stroke: '#79ca31', strokeWidth: 2, r: 4, strokeOpacity: 0.8 }}
                activeDot={{ r: 6, stroke: '#fff', strokeWidth: 2, fill: '#79ca31' }}
                strokeLinecap="round"
              />
              {transformedData.length > 1 && (
                <Line 
                  type="monotone" 
                  dataKey="weight" 
                  stroke="#4a6baf" 
                  strokeWidth={2}
                  strokeDasharray="5 5"
                  dot={false}
                  activeDot={false}
                  strokeOpacity={0.6}
                />
              )}
            </LineChart>
          </ResponsiveContainer>
        </div>

        <div className="mt-2">
          {transformedData.length > 1 && (
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <div className="text-muted small">Dernière mesure</div>
                <div className="fw-bold" style={{ color: '#79ca31' }}>
                  {transformedData[transformedData.length - 1]?.weight} kg
                </div>
              </div>
              <div className="text-end">
                <div className="text-muted small">Évolution</div>
                <div className={`fw-bold ${(transformedData[transformedData.length - 1]?.weight - transformedData[0]?.weight) >= 0 ? 'text-danger' : 'text-success'}` }>
                  {transformedData.length > 1 ? 
                    `${((transformedData[transformedData.length - 1]?.weight - transformedData[0]?.weight) * 1000 / 1000).toFixed(1)} kg`  : 
                    'N/A'}
                </div>
              </div>
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  </Col>
</Row>
   
      
   
   
      
   
       <Row style={{ padding: "20px" }}>
         {/* Colonne des macronutriments */}
         <Col xs={12} md={6} xl={6} className="mb-4">
           <Card className="h-100">
             <Card.Body className="p-4 d-flex flex-column">
               <h2 style={{ color: "#79ca31" }} className="text-xl font-bold mb-4 text-center">
                 Macronutriments du jour
               </h2>
               <div className="d-flex flex-column w-100">
             <div className="d-flex flex-column align-items-center p-3" style={{ minWidth: "250px" }}>
               <div style={{ position: 'relative', width: '100%', height: '100%', maxWidth: '250px' }}>
                 <svg width="100%" height="100%" viewBox="0 0 120 120">
                   <circle cx="60" cy="60" r="50" fill="#f8f9fa" />
                   
                   {macroData.map((macro, index) => {
                     const radius = 50 - (index * 12);
                     const circumference = 2 * Math.PI * radius;
                     const value = macro.value > 0 ? macro.value : 0;
                     const goal = macro.goal > 0 ? macro.goal : 1;
                     const progress = Math.min((value / goal) * 100, 100);
                     const strokeDashoffset = circumference * (1 - progress / 100);
                     
                     return (
                       <g key={macro.name}>
                         <circle 
                           cx="60" 
                           cy="60" 
                           r={radius} 
                           fill="transparent" 
                       stroke="#e9ecef" 
                       strokeWidth="8"
                     />
                     <circle
                       cx="60"
                       cy="60"
                       r={radius}
                       fill="transparent"
                       stroke={macro.color}
                       strokeWidth="8"
                       strokeDasharray={circumference}
                       strokeDashoffset={strokeDashoffset}
                       strokeLinecap="round"
                       transform="rotate(-90 60 60)"
                       style={{ 
                         transition: "stroke-dashoffset 0.8s ease-in-out",
                         filter: 'drop-shadow(0 0 5px rgba(0,0,0,0.1))'
                       }}
                     />
                   </g>
                 );
               })}
               
               {/* Texte central */}
               <text 
                 x="60" 
                 y="55" 
                 textAnchor="middle" 
                 fontSize="10" 
                 fill="#666" 
                 fontWeight="bold"
                 style={{ fontFamily: 'sans-serif' }}
               >
                 Objectifs
               </text>
               <text 
                 x="60" 
                 y="70" 
                 textAnchor="middle" 
                 fontSize="8" 
                 fill="#888"
                 style={{ fontFamily: 'sans-serif' }}
               >
                 Macronutriments
               </text>
             </svg>
             
             {/* Légende des couleurs */}
             <div style={{
               position: 'absolute',
               bottom: '0',
               left: '50%',
               transform: 'translateX(-50%)',
               display: 'flex',
               flexWrap: 'wrap',
               justifyContent: 'center',
               gap: '8px',
               marginTop: '10px'
             }}>
               {macroData.map((macro, index) => (
                 <div key={index} style={{
                   display: 'flex',
                   alignItems: 'center',
                   margin: '2px 0'
                 }}>
                   <div style={{
                     width: '12px',
                     height: '12px',
                     backgroundColor: macro.color,
                     borderRadius: '50%',
                     marginRight: '4px',
                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                   }} />
                   <span style={{
                     fontSize: '10px',
                     color: '#666',
                     whiteSpace: 'nowrap'
                   }}>
                     {macro.name}
                   </span>
                 </div>
               ))}
             </div>
           </div>
         </div>
     
         {/* Tableau (scrollable sur mobile) */}
         <div className="table-responsive mt-3" style={{ width: "100%" }}>
       <Table className="table table-hover table-borderless text-center" 
         style={{ width: "100%", fontSize: "12px" }}>
         <thead>
           <tr>
             <th>Couleur</th>
             <th>Name</th>
             <th>Value</th>
             <th>%</th>
           </tr>
         </thead>
         <tbody>
           {macroData.map((macro) => {
             const percentage = ((macro.value / macro.goal) * 100).toFixed(1);
             return (
               <tr key={macro.name}>
                 <td>
                   <div style={{ backgroundColor: macro.color, width: "15px", height: "15px", borderRadius: "50%" }}></div>
                 </td>
                 <td style={{ fontWeight: "bold", color:"#999" }}>{macro.name}</td>
                 <td style={{ fontWeight: "bold", color:"#1E88E5" }}>{macro.value}g</td>
                 <td style={{ fontWeight: "bold", color:"yellowgreen" }}>{percentage}%</td>
               </tr>
             );
           })}
         </tbody>
       </Table>
     </div>
   </div>
 </Card.Body>
</Card>
</Col>
     
     {/* Colonne du graphique d'évolution */}
{/* Colonne du graphique d'évolution */}
<Col xs={12} md={6} xl={6} className="mb-4">
  <Card className="h-100 border-0" style={{
    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
    borderRadius: '20px',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)',
    overflow: 'hidden'
  }}>
    <Card.Body className="p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="mb-1 fw-bold" style={{ color: '#2c3e50' }}>
            Vue d'ensemble nutritionnelle
          </h4>
          <p className="text-muted small mb-0">Évolution de vos apports quotidiens</p>
        </div>
        <div style={{
          width: '48px',
          height: '48px',
          borderRadius: '12px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
        }}>
          <i className="fas fa-chart-line" style={{ color: '#fff', fontSize: '20px' }}></i>
        </div>
      </div>
      
      <div style={{ height: '400px', width: '100%', minHeight: '300px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={chartData}
            margin={{ top: 10, right: 10, left: 0, bottom: 10 }}
          >
            <defs>
              <linearGradient id="caloriesConsumed" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#4dabf7" stopOpacity={0.3}/>
                <stop offset="95%" stopColor="#4dabf7" stopOpacity={0}/>
              </linearGradient>
              <linearGradient id="caloriesBurned" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#ff6b6b" stopOpacity={0.3}/>
                <stop offset="95%" stopColor="#ff6b6b" stopOpacity={0}/>
              </linearGradient>
              <linearGradient id="proteins" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#20c997" stopOpacity={0.3}/>
                <stop offset="95%" stopColor="#20c997" stopOpacity={0}/>
              </linearGradient>
              <linearGradient id="carbs" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#ffc078" stopOpacity={0.3}/>
                <stop offset="95%" stopColor="#ffc078" stopOpacity={0}/>
              </linearGradient>
              <linearGradient id="fats" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#9775fa" stopOpacity={0.3}/>
                <stop offset="95%" stopColor="#9775fa" stopOpacity={0}/>
              </linearGradient>
            </defs>
            
            <CartesianGrid 
              strokeDasharray="3 3" 
              stroke="#e9ecef" 
              vertical={false}
              strokeOpacity={0.5}
            />
            
            <XAxis 
              dataKey="date" 
              tick={{ fill: '#6c757d', fontSize: 12 }}
              tickLine={false}
              axisLine={{ stroke: '#e9ecef', strokeWidth: 1 }}
              padding={{ left: 20, right: 20 }}
            />
            
            <YAxis 
              yAxisId="left" 
              orientation="left" 
              tick={{ fill: '#6c757d', fontSize: 12 }}
              tickLine={false}
              axisLine={false}
              label={{ 
                value: 'Calories (kcal)', 
                angle: -90, 
                position: 'insideLeft', 
                fill: '#6c757d',
                style: { fontSize: 12, fontWeight: 500 }
              }}
            />
            
            <YAxis 
              yAxisId="right" 
              orientation="right" 
              tick={{ fill: '#6c757d', fontSize: 12 }}
              tickLine={false}
              axisLine={false}
              label={{ 
                value: 'Macros (g)', 
                angle: 90, 
                position: 'insideRight', 
                fill: '#6c757d',
                style: { fontSize: 12, fontWeight: 500 }
              }}
            />
            
            <Tooltip 
              contentStyle={{
                backgroundColor: 'rgba(255, 255, 255, 0.98)',
                border: 'none',
                borderRadius: '12px',
                boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                padding: '12px 16px'
              }}
              labelStyle={{ 
                color: '#2c3e50', 
                fontWeight: 600, 
                marginBottom: '8px',
                fontSize: 13
              }}
              itemStyle={{ 
                padding: '4px 0',
                fontSize: 12
              }}
              formatter={(value, name) => {
                const unit = name.includes('Calories') ? ' kcal' : ' g';
                return [`${Math.round(value)}${unit}`, name];
              }}
            />
            
            <Legend 
              verticalAlign="top"
              height={60}
              iconType="circle"
              wrapperStyle={{
                paddingBottom: '20px',
                fontSize: '13px'
              }}
              iconSize={10}
            />
            
              {/* Calories consommées */}
              <Line 
              yAxisId="left"
              type="natural" 
              dataKey="caloriesConsumed" 
              name="Calories consommées"
              stroke="#4dabf7" 
              strokeWidth={3}
              fill="url(#caloriesConsumed)"
              dot={{ fill: '#4dabf7', strokeWidth: 0, r: 4 }}
              activeDot={{ 
                r: 7, 
                stroke: '#fff', 
                strokeWidth: 3,
                fill: '#4dabf7',
                filter: 'drop-shadow(0 2px 4px rgba(77, 171, 247, 0.4))'
              }}
              strokeLinecap="round"
            />
            
            {/* Calories brûlées */}
            <Line 
              yAxisId="left"
              type="natural" 
              dataKey="caloriesBurned" 
              name="Calories brûlées"
              stroke="#ff6b6b"
              strokeWidth={3}
              fill="url(#caloriesBurned)"
              dot={{ fill: '#ff6b6b', strokeWidth: 0, r: 4 }}
              activeDot={{ 
                r: 7, 
                stroke: '#fff', 
                strokeWidth: 3,
                fill: '#ff6b6b',
                filter: 'drop-shadow(0 2px 4px rgba(255, 107, 107, 0.4))'
              }}
              strokeLinecap="round"
            />
            
            {/* Protéines */}
            <Line 
              yAxisId="right"
              type="natural" 
              dataKey="proteins" 
              name="Protéines"
              stroke="#20c997"
              strokeWidth={2.5}
              strokeDasharray="5 5"
              dot={{ fill: '#20c997', strokeWidth: 0, r: 3 }}
              activeDot={{ 
                r: 6, 
                stroke: '#fff', 
                strokeWidth: 2,
                fill: '#20c997'
              }}
            />
            
            {/* Glucides */}
            <Line 
              yAxisId="right"
              type="natural" 
              dataKey="carbs" 
              name="Glucides"
              stroke="#ffc078"
              strokeWidth={2.5}
              strokeDasharray="5 5"
              dot={{ fill: '#ffc078', strokeWidth: 0, r: 3 }}
              activeDot={{ 
                r: 6, 
                stroke: '#fff', 
                strokeWidth: 2,
                fill: '#ffc078'
              }}
            />
            
            {/* Lipides */}
            <Line 
              yAxisId="right"
              type="natural" 
              dataKey="fats" 
              name="Lipides"
              stroke="#9775fa"
              strokeWidth={2.5}
              strokeDasharray="5 5"
              dot={{ fill: '#9775fa', strokeWidth: 0, r: 3 }}
              activeDot={{ 
                r: 6, 
                stroke: '#fff', 
                strokeWidth: 2,
                fill: '#9775fa'
              }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </Card.Body>
  </Card>
</Col>
</Row>
   
   
     
        
         
      
    
       <Row className="justify-content-center g-4" style={{ padding: "15px 0" }}>
  <Col xs={12}>
    <Card className="border-0 shadow-sm">
      <Card.Body className="p-3 p-md-4">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3 mb-md-4">
          <h2 className="m-0 mb-3 mb-md-0" style={{ color: "#2c3e50", fontSize: '1.3rem', fontWeight: '600' }}>
            <i className="ri-restaurant-2-line me-2" style={{ color: '#79ca31' }}></i>
            Repas enregistrés aujourd'hui
          </h2>
          <Badge bg="light" text="dark" className="px-3 py-2" style={{ fontSize: '0.85rem' }}>
            {nextDailyPlan?.dailyMeals?.length || 0} repas
          </Badge>
        </div>
        
        <div className="table-responsive" style={{ 
          overflowX: 'auto', 
          WebkitOverflowScrolling: 'touch', 
          msOverflowStyle: '-ms-autohiding-scrollbar',
          width: '100%',
          display: 'block'
        }}>
          <Table hover responsive="sm" className="align-middle mb-0" style={{ 
            minWidth: '100%',
            tableLayout: 'fixed'
          }}>
            <thead className="bg-light ">
              <tr>
                <th style={{ 
                  color: "#4a6baf", 
                  padding: '10px 8px', 
                  borderBottom: '2px solid #e9ecef', 
                  width: '20%',
                  minWidth: '120px'
                }}>Repas</th>
                <th style={{ 
                  color: "#4a6baf", 
                  padding: '10px 8px', 
                  borderBottom: '2px solid #e9ecef',
                  width: '15%',
                  minWidth: '100px'
                }}>Catégorie</th>
                <th style={{ 
                  color: "#4a6baf", 
                  padding: '10px 8px', 
                  borderBottom: '2px solid #e9ecef', 
                  textAlign: 'center',
                  width: '10%',
                  minWidth: '80px'
                }}>Calories</th>
                <th style={{ 
                  color: "#4a6baf", 
                  padding: '10px 8px', 
                  borderBottom: '2px solid #e9ecef', 
                  textAlign: 'center',
                  width: '10%',
                  minWidth: '80px'
                }}>Cal. brûlées</th>
                <th className="d-none d-md-table-cell" style={{ 
                  color: "#4a6baf", 
                  padding: '10px 8px', 
                  borderBottom: '2px solid #e9ecef', 
                  textAlign: 'center',
                  width: '10%',
                  minWidth: '80px'
                }}>Protéines</th>
                <th className="d-none d-md-table-cell" style={{ 
                  color: "#4a6baf", 
                  padding: '10px 8px', 
                  borderBottom: '2px solid #e9ecef', 
                  textAlign: 'center',
                  width: '10%',
                  minWidth: '80px'
                }}>Lipides</th>
                <th className="d-none d-md-table-cell" style={{ 
                  color: "#4a6baf", 
                  padding: '10px 8px', 
                  borderBottom: '2px solid #e9ecef', 
                  textAlign: 'center',
                  width: '10%',
                  minWidth: '80px'
                }}>Glucides</th>
                <th style={{ 
                  color: "#4a6baf", 
                  padding: '10px 8px', 
                  borderBottom: '2px solid #e9ecef', 
                  textAlign: 'center',
                  width: '15%',
                  minWidth: '100px'
                }}>Statut</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(nextDailyPlan?.dailyMeals) && nextDailyPlan.dailyMeals?.length > 0 ? (
                nextDailyPlan.dailyMeals.map((meal, index) => (
                  <tr key={index} style={{ borderBottom: '1px solid #f1f3f9' }}>
                    <td style={{ padding: '12px 50px 12px 40px',  minWidth: '50px', fontWeight: '600' }} data-label="Repas">
                      <div className="d-flex align-items-center">
                        <div className="me-2 d-none d-md-block" style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#79ca31' }}></div>
                        <div className="d-flex flex-column">
                          <span className="d-inline d-md-none text-muted small">Repas:</span>
                          <div className="text-truncate" style={{ maxWidth: '250px' }}>
                            {meal.recipe?.recipeName || "N/A"}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td style={{ padding: '12px' }} data-label="Catégorie">
                      <div className="d-flex flex-column">
                        <span className="d-inline d-md-none text-muted small mb-1">Catégorie:</span>
                        <Badge bg="warning" className="text-dark d-inline-flex justify-content-center" style={{ fontWeight: '500', backgroundColor: '#fff3e0', width: 'fit-content' }}>
                          {meal.recipe?.category || "N/A"}
                        </Badge>
                      </div>
                    </td>
                    {/* <td style={{ padding: '12px', color: '#6c757d' }} data-label="Description">
                      <div className="d-flex flex-column">
                        <span className="d-inline d-md-none text-muted small mb-1">Description:</span>
                        <div className="text-truncate" style={{ maxWidth: '200px' }}>
                          {meal.recipe?.description || "Aucune description"}
                        </div>
                      </div>
                    </td> */}
                    <td style={{ padding: '12px', color: '#79ca31', fontWeight: 'bold', textAlign: 'center' }} data-label="Calories">
                      <div className="d-flex flex-column">
                        <span className="d-inline d-md-none text-muted small">Calories</span>
                        {meal.recipe?.totalNV?.calories || 0} <small>kcal</small>
                      </div>
                    </td>
                    <td style={{ padding: '12px', color: '#ff6b6b', fontWeight: 'bold', textAlign: 'center' }} data-label="Cal. brûlées">
                      <div className="d-flex flex-column">
                        <span className="d-inline d-md-none text-muted small">Cal. brûlées</span>
                        {meal.recipe?.caloriesBurnedOfMeal || 0} <small>kcal</small>
                      </div>
                    </td>
                    <td className="d-none d-md-table-cell" style={{ padding: '12px', color: '#1E88E5', fontWeight: 'bold', textAlign: 'center' }} data-label="Protéines">
                      <div className="d-flex flex-column">
                        <span className="d-inline d-md-none text-muted small">Protéines</span>
                        {meal.recipe?.totalNV?.protein || 0} <small>g</small>
                      </div>
                    </td>
                    <td className="d-none d-md-table-cell" style={{ padding: '12px', color: '#71ccde', fontWeight: 'bold', textAlign: 'center' }} data-label="Lipides">
                      <div className="d-flex flex-column">
                        <span className="d-inline d-md-none text-muted small">Lipides</span>
                        {meal.recipe?.totalNV?.fats || 0} <small>g</small>
                      </div>
                    </td>
                    <td className="d-none d-md-table-cell" style={{ padding: '12px', color: '#43A047', fontWeight: 'bold', textAlign: 'center' }} data-label="Glucides">
                      <div className="d-flex flex-column">
                        <span className="d-inline d-md-none text-muted small">Glucides</span>
                        {meal.recipe?.totalNV?.carbs || 0} <small>g</small>
                      </div>
                    </td>
                    <td style={{ padding: '12px 40px 12px 10px', textAlign: 'center' }} data-label="Statut">
                      <div className="d-flex flex-column">
                        <span className="d-inline d-md-none text-muted small mb-1">Statut</span>
                        {meal.consumed ? (
                          <Badge bg="success" className="d-inline-flex align-items-center justify-content-center" style={{ padding: '4px 8px', fontSize: '0.8rem' }}>
                            <CheckCircle size={14} className="me-1" /> <span className="d-none d-md-inline">Consommé</span>
                          </Badge>
                        ) : (
                          <Badge bg="danger" className="d-inline-flex align-items-center justify-content-center" style={{ padding: '4px 8px', fontSize: '0.8rem' }}>
                            <XCircle size={14} className="me-1" /> <span className="d-none d-md-inline">En attente</span>
                          </Badge>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center py-4" style={{ color: '#6c757d' }}>
                    <div className="d-flex flex-column align-items-center justify-content-center py-4">
                      <i className="ri-information-line" style={{ fontSize: '2rem', color: '#adb5bd', marginBottom: '10px' }}></i>
                      <p className="mb-3 text-center">Aucun repas enregistré pour aujourd'hui</p>
                      
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  </Col>
</Row>
</div>


   
    
      {/* Hydration Tracker */}
      
    </div>
  );
  
            }


export default NutritionDashboard;

